<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">计划单号</span>
         <el-input
          placeholder="请输入关键词"
          v-model="conditions.pno"
          clearable
        >
        </el-input>
        <span class="fonints">货主名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.customname"
          clearable
        >
        </el-input>
        <span class="fonints">流向</span>
         <el-input
          placeholder="请输入关键词"
          v-model="conditions.customername"
          clearable
        >
        </el-input>
        <button class="buttons" @click.stop="queryTableInfo">查询</button>
      </div>
      <div class="componentSty_content_table" style="border:none">
        <el-table
         height="80%"
          style="width: 100%; height: 80%"
          :data="arrlist.data"
          ref="tableRef"
          lazy
          row-key="id"
          @row-click="tableRowClidk"
          border
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
        <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="pno" label="计划单号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="goodsname" label="货物名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customername" label="流向"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customname" label="货主名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="agentname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="代理名称">
            <template v-slot="res">
              <span style="color: orange">
                {{ res.row.fleetName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="计划吨数">
            <template v-slot="res">
              <span>{{ res.row.plantons || "" }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="本地状态">
            <template v-slot="res">
              <span
                v-if="res.row.localhoststatus == 0"
                @click="changeLocalhoststatus(res.row)"
                style="color: rgb(19, 209, 105); cursor: pointer"
                >进行中</span
              >
              <span v-if="res.row.localhoststatus == 1" style="color: blue"
                >完成</span
              >
              <span
                v-if="res.row.localhoststatus == 2"
                @click="changeLocalhoststatus(res.row)"
                style="color: #fcad50;cursor: pointer"
                >暂停</span
              >
              <span
                v-if="res.row.localhoststatus == 3"
                style="color: rgb(254, 90, 36)"
                >作废</span
              >
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="状态">
            <template v-slot="res">
              <div class="iconfont" v-if="res.row.pno">
                <span
                  style="color: rgb(19, 209, 104)"
                  @click="changeState(res.row, 0, ...[, 'all'])"
                  >审核</span
                >
                <span>/</span>
                <span
                  style="color: blue"
                  @click="changeState(res.row, 1, 'status', 'all')"
                  >不审核</span
                >
              </div>
              <div class="iconfont" v-else>
                <span
                  style="color: rgb(19, 209, 104)"
                  v-if="res.row.status == 0"
                  @click="changeState(res.row, 0)"
                  >后台审核</span
                >
                <span
                  style="color: blue"
                  v-if="res.row.status == 1"
                  @click="changeState(res.row, 1, 'status')"
                  >后台不审核</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="支付">
            <template v-slot="res">
              <div class="iconfont" v-if="res.row.pno">
                <span
                  style="color: rgb(19, 209, 104)"
                  @click="changeState(res.row, 1, 'paymentChannel', 'all')"
                  >线上</span
                >
                <span>/</span>
                <span
                  style="color: blue"
                  @click="changeState(res.row, 2, ...[, 'all'])"
                  >线下</span
                >
              </div>
              <div class="iconfont" v-else>
                <span
                  style="color: rgb(19, 209, 104)"
                  v-show="res.row.paymentChannel == 1"
                  @click="changeState(res.row, 1, 'paymentChannel')"
                  >线上支付</span
                >
                <span
                  style="color: blue"
                  v-show="res.row.paymentChannel == 2"
                  @click="changeState(res.row, 2)"
                  >线下支付</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-if="arrlist.data&&arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
             layout="total,prev, pager,next, jumper"
            :total="arrlist.Count"
            :current-page="conditions.page"
            @current-change="gainTableList"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "计划管理" }, { name: "计划详情" }],
      itemindex: null,
      conditions: {},
      arrlist: {},
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
     this.conditionsList[this.$route.path] ||
      this.createConditions({ key: this.$route.path });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
    };
    this.gainTableList();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async gainTableList(num) {
      console.log(num)
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/fleet/plan/getPcPlanList",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      if (typeof this.itemindex==="number"&&!num) {
        this.$set(this.arrlist.data[this.itemindex],"localhoststatus",data.data[this.itemindex]["localhoststatus"])
      } else {
        data.data.forEach((item, index) => {
          item["children"] = [];
          item["hasChildren"] = true;
          item["isClos"] = true;
          item["rowItemIndex"] = index;
        });
        this.arrlist = data;
      }
    },
    async gainRowInfoList(row) {
      const { data } = await this.$http(
        "api1",
        "/fleet/planfleetmessage/getPlanFleetByPlanId",
        "post",
        {
          planId: row.id,
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      row.pno && (row.children = data.data);
      row.pno &&row.isClos&&this.$refs.tableRef.toggleRowExpansion(row, true);
      !row.pn &&
        this.arrlist.data.some((item) => {
          if (item.id == row.id) {
            item.children = data.data;
            return true;
          } else {
            return false;
          }
        });
      row.isClos === true && (row.isClos = false);
    },
    async changeState(row, num, info, isAll) {
      let path = "";
      switch (num) {
        case 0:
          path = isAll
            ? "/fleet/planfleetmessage/backstageAuditByPno"
            : "/fleet/planfleetmessage/backstageNotAudit";
          break;
        case 1:
          info == "status" &&
            (path = isAll
              ? "/fleet/planfleetmessage/backstageNotAuditByPno"
              : "/fleet/planfleetmessage/backstageAudit");
          info == "paymentChannel" &&
            (path = isAll
              ? "/fleet/planfleetmessage/updatePaymentChannelOnlinePaymentByPno"
              : "/fleet/planfleetmessage/updatePaymentChannelOfflinePayment");
          break;
        case 2:
          path = isAll
            ? "/fleet/planfleetmessage/updatePaymentChannelOfflinePaymentByPno"
            : "/fleet/planfleetmessage/updatePaymentChannelOnlinePayment";
          break;
      }
      const { data } = await this.$http("api1", path, "post", {
        ids: [row.id],
      });
      if (data.code != 0) return this.$message.error(data.msg);
      row.pno
        ? this.gainRowInfoList(row)
        : this.gainRowInfoList({ id: row.planId });
    },
    async changeLocalhoststatus(row) {
      this.itemindex = row.rowItemIndex;
      let api = "";
      switch (row.localhoststatus) {
        case "0":
          api = "/fleet/plan/planToSuspend";
          break;
        case "2":
          api = "/fleet/plan/planToStart";
          break;
      }
      if (!api) return "";
      const { data } = await this.$http("api1", api, "post", {
        id: row.id,
      });
      if (data.code != 0) return this.$message.error(data.msg);
      this.gainTableList();
    },
    tableRowClidk(row, column) {
      if (
        column.label === "状态" ||
        column.label === "支付" ||
        column.label === "本地状态" ||
        !row.pno
      )
        return "";
      if (row.isClos === false) {
        row.isClos = true;
        return this.$refs.tableRef.toggleRowExpansion(row, false);
      }
      this.itemindex = row.rowItemIndex;
      this.gainRowInfoList(row);
    },
    queryTableInfo() {
      antiShake((_) => {
        this.itemindex = null;
        this.conditions.page = 1;
        this.gainTableList();
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.Count < this.conditions.limit) return;
      this.itemindex = null;
      this.conditions.page = index;
      this.gainTableList();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>



